import { useRef, useState } from 'react';
import { Upload, FileText } from 'lucide-react';

/**
 * Drag-and-drop + click-to-browse PDF upload zone shared by the New Request
 * Wizard and the Template editor.
 */
export function PdfDropZone({ onFile, fileName, testId = 'pdf-drop-zone' }) {
  const inputRef = useRef(null);
  const [dragOver, setDragOver] = useState(false);

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer?.files?.[0];
    if (file) onFile(file);
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => inputRef.current?.click()}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') inputRef.current?.click(); }}
      onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
      onDragLeave={() => setDragOver(false)}
      onDrop={handleDrop}
      className={`flex flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed px-4 py-8 text-center cursor-pointer transition-colors ${
        dragOver
          ? 'border-emerald-500 bg-emerald-50 dark:bg-emerald-950/30'
          : 'border-muted-foreground/25 hover:border-emerald-400 hover:bg-emerald-50/40 dark:hover:bg-emerald-950/20'
      }`}
      data-testid={testId}
    >
      <input
        ref={inputRef}
        type="file"
        accept="application/pdf"
        className="hidden"
        onChange={(e) => { const f = e.target.files?.[0]; if (f) onFile(f); e.target.value = ''; }}
        data-testid={`${testId}-input`}
      />
      {fileName ? (
        <>
          <FileText className="w-6 h-6 text-emerald-600" />
          <p className="text-sm font-medium text-emerald-700 dark:text-emerald-300">{fileName}</p>
          <p className="text-xs text-muted-foreground">Drop a different PDF or click to replace</p>
        </>
      ) : (
        <>
          <Upload className={`w-6 h-6 ${dragOver ? 'text-emerald-600' : 'text-muted-foreground'}`} />
          <p className="text-sm font-medium">
            {dragOver ? 'Drop your PDF here' : 'Drag & drop a PDF here'}
          </p>
          <p className="text-xs text-muted-foreground">or click to browse · PDF only, max 20 MB</p>
        </>
      )}
    </div>
  );
}

export default PdfDropZone;
